export default "__VITE_ASSET__DeZk9FxQ__"